import axios from 'axios';
import store from '../store';
import getLocalUserData from './getLocalUserData';

const apiUrl = {
  lineage: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: 'https://rc-apilineage.plaync.com/api/main/cnb/userData',
    live: 'https://api-lineage.plaync.com/api/main/cnb/userData'
  },

  lineage2: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: 'https://rc-api-lineage2.plaync.com/cnb/user',
    live: 'https://api-lineage2.plaync.com/cnb/user'
  },

  aion: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: 'https://rc-api-aion.plaync.com/webcontents/v2/cnb/userData',
    live: 'https://api-aion.plaync.com/webcontents/v2/cnb/userData'
  },

  bns: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: 'https://rc-api-bns.plaync.com/web/v2/cnb/userData',
    live: 'https://api-bns.plaync.com/web/v2/cnb/userData'
  },

  lovebeat: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: '/promo/api/uiutil/v/1/userdatajson',
    live: '/promo/api/uiutil/v/1/userdatajson'
  },

  plaync: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: '/promo/api/uiutil/v/1/userdatajson',
    live: '/promo/api/uiutil/v/1/userdatajson'
  },

  lineagem: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: 'https://rc-lineagem.plaync.com/cnb/userData',
    live: 'https://lineagem.plaync.com/cnb/userData'
  },

  lineage2m: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: 'https://rc-lineage2m.plaync.com/cnb/userData',
    live: 'https://lineage2m.plaync.com/cnb/userData'
  },

  h2: {
    local: '/promo/api/uiutil/v/1/userdatajson',
    sb: '/promo/api/uiutil/v/1/userdatajson',
    op: '/promo/api/uiutil/v/1/userdatajson',
    rc: 'https://rc-h2.plaync.com/cnb/userData',
    live: 'https://h2.plaync.com/cnb/userData'
  }
};

const getUserData = () => {
  let network = store('network');

  if (/file|wstatic/.test(network)) {
    window.userData = getLocalUserData();
    store('userData', window.userData);
    $(window).trigger('promokitUserDataReady');
  }
  else {
    axios({
      url: apiUrl[store('game')][network],
      withCredentials: true
    }).then((d) => {
      window.userData = d.data;
      store('userData', window.userData);
      $(window).trigger('promokitUserDataReady');
    }).catch(function(error) {
      console.log(error);
      console.error('fail loaded userData');
    });
  }
};

export default getUserData;
